import type { ChartColors } from './types'

export const ANIMATION_DURATION = 600

export const chartColors: ChartColors = {
  light: {
    series: {
      primary: '#0042FF',
      secondary: '#B5B3B0',
      areaPrimary: '#0042FF',
      areaSecondary: '#6F6F69',
    },
    general: {
      axisLine: '#E1E0DF',
      axisLabel: '#6E6E68',
      splitLine: '#E1E0DF',
    },
  },
  dark: {
    series: {
      primary: '#0042FF',
      secondary: '#B5B3B0',
      areaPrimary: '#0042FF',
      areaSecondary: '#6F6F69',
    },
    general: {
      axisLine: '#343531',
      axisLabel: '#B5B3B0',
      splitLine: '#343531',
    },
  },
}
